export default __webpack_public_path__ + "static/media/play-solid.5d1bea8d.svg";